export const login = (username, password) => {
  if (username && password) {
    const token = `mock-token-${Date.now()}`;
    localStorage.setItem('authToken', token);
    localStorage.setItem('username', username);
    return { success: true, token };
  }
  return { success: false, error: 'ID와 비밀번호를 입력해주세요' };
};

export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('username');
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};

export const getUsername = () => {
  return localStorage.getItem('username') || 'Guest';
};
